"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supplier = void 0;

var _crm = require("./crm");

var _inventoryFlows = require("./inventoryFlows");

var _mainNavigation = require("./mainNavigation");

var _mySettings = require("./mySettings");

var _orders = require("./orders");

var _outlets = require("./outlets");

var _products = require("./products");

var _reports = require("./reports");

var _settings = require("./settings");

var supplier = {
  CRM: _crm.CRM,
  INVENTORY_FLOWS: _inventoryFlows.INVENTORY_FLOWS,
  MAIN_NAVIGATION: _mainNavigation.MAIN_NAVIGATION,
  MY_SETTINGS: _mySettings.MY_SETTINGS,
  ORDERS: _orders.ORDERS,
  OUTLETS: _outlets.OUTLETS,
  PRODUCTS: _products.PRODUCTS,
  REPORTS: _reports.REPORTS,
  SETTINGS: _settings.SETTINGS
};
exports.supplier = supplier;